import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import View from './View';
import { ORDER_TABS } from '../config';
import { clone, filterItems } from '../../../../utils/arrayProcessor';
import { crudSuccess as crudRequestConfig } from '../invoiced/config';
import { ALERT_TYPE } from '../../../../data/enums/AlertType';
import withAlert from '../../../../utils/composition/withAlert';
import { EVENT_OPERATION } from '../../../../data/enums/EventOperation';
import { handleFormSubmit } from '../../../../utils/crudResponseProcessor';
import { LIMIT, PAGE } from '../../../../data/enums/GeneralConstants';
import { TableHeader } from './tableConfig';

const propTypes = {
  data: PropTypes.shape({
    list: PropTypes.array,
    total: PropTypes.number,
  }),
  activeLine: PropTypes.shape({
    id: PropTypes.number,
    sellerId: PropTypes.number,
  }),
  serverResponseWaiting: PropTypes.bool,
  stateSetter: PropTypes.func.isRequired,
  displayAlert: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onCallRowClick: PropTypes.func.isRequired,
  deliverInvoice: PropTypes.func.isRequired,
  handlePassiveTabListChange: PropTypes.func.isRequired,
  onHeaderClick: PropTypes.func,
};

const defaultProps = {
  data: {
    list: [],
    total: 0,
    limit: LIMIT,
    page: PAGE,
  },
  activeLine: {
    id: '',
    sellerId: 0,
  },
  serverResponseWaiting: false,
  onHeaderClick: () => null,
};

class Dispatched extends Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedOrders: [],
      activeCall: {
        index: -1,
        value: '',
        sellerId: '',
      },
    };

    const serverCall = {
      [EVENT_OPERATION.DELIVERED]: props.deliverInvoice,
    };
    this.onFormSubmit = handleFormSubmit(
      this.onServerRequestSuccess,
      this.onAPIRequestFailure,
      crudRequestConfig,
      serverCall,
    );
    this.permission = this.getUserPermission();
  }

  componentDidMount() {
    const { onHeaderClick } = this.props;
    this.resetActiveCall();
    TableHeader({ onHeaderClick, dynamicHeader: true });
  }

  getUserPermission = () => ({ GRN: {} });
  // todo fetch user permission here

  resetActiveCall = () => {
    const { activeCall } = this.state;
    activeCall.index = '';
    activeCall.value = '';
    activeCall.sellerId = '';
    this.setState({ activeCall });
  };

  handleRowClick = (callId, sellerId, refId, orderType) => {
    const { onCallRowClick, data } = this.props;
    const { activeCall } = this.state;
    if (callId !== activeCall.value) {
      const indexInDataList = data.list.findIndex(
        element => element.Distributor.id === sellerId && element.id === callId,
      );
      activeCall.value = callId;
      activeCall.index = indexInDataList;
      this.setState({ activeCall });

      onCallRowClick(callId, sellerId, refId, orderType);
    }
  };

  onAPIRequestFailure = error => {
    const { displayAlert } = this.props;
    displayAlert(ALERT_TYPE.DANGER, error);
    console.log(error);
  };

  onServerRequestSuccess = type => response => {
    const { displayAlert, data, stateSetter, handlePassiveTabListChange } = this.props;
    const dataList = clone(data.list);
    displayAlert(ALERT_TYPE.SUCCESS, crudRequestConfig[type].message);
    const selectedCall = filterItems(dataList, response.id)[0] || {};
    const selectedCallIndex = dataList.findIndex(call => call.id === selectedCall.id);
    dataList.splice(selectedCallIndex, 1);
    data.list = dataList;
    data.total -= 1;
    stateSetter(data, ORDER_TABS.DISPATCHED);
    handlePassiveTabListChange(response.id, ORDER_TABS[type], 1);
  };

  handlePageChange = pagination => {
    const { onPageChange } = this.props;
    onPageChange(ORDER_TABS.DISPATCHED, pagination);
  };

  render() {
    const { selectedOrders } = this.state;
    const { data, activeLine, serverResponseWaiting, onHeaderClick } = this.props;

    return (
      <Fragment>
        <View
          data={data}
          activeLine={activeLine}
          onPageChange={this.handlePageChange}
          selectedOrders={selectedOrders}
          loading={serverResponseWaiting}
          onRowClick={this.handleRowClick}
          onOrderStatusChangeClick={this.onFormSubmit}
          onHeaderClick={onHeaderClick}
        />
      </Fragment>
    );
  }
}

Dispatched.propTypes = propTypes;

Dispatched.defaultProps = defaultProps;

export default withAlert()(Dispatched);
